var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6304_50370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 0.931641H0V64.9316H64V0.931641Z",
    fill: "#445689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6166 42.1361H47.7515C48.5997 37.047 49.4456 31.9625 50.2984 26.8477H21.0674C21.9202 31.9625 22.7661 37.047 23.6143 42.1361H23.6166Z",
    fill: "#D0F19A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5088 23.4512C20.6046 24.026 20.6934 24.5611 20.7845 25.1055H50.595C50.6838 24.5307 50.7656 23.9979 50.8497 23.4512H20.5088Z",
    fill: "#D0F19A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4071 44.7314H21.1022C21.0601 44.5912 21.0204 44.493 21.0041 44.3879C20.6793 42.4462 20.3568 40.5044 20.0344 38.5604C19.0063 32.3847 17.9758 26.2067 16.9454 20.031C16.8379 19.3815 16.5645 19.1571 15.8986 19.1525C14.9055 19.1478 13.9101 19.1525 12.917 19.1525C11.9988 19.1525 11.0828 19.1525 10.1528 19.1525V20.8675H15.3284C15.3682 20.9937 15.4032 21.0755 15.4172 21.162C15.8542 23.786 16.2864 26.4123 16.7234 29.0363C17.6323 34.4947 18.5436 39.9553 19.4596 45.4113C19.6044 46.2759 19.8147 46.4371 20.7003 46.4394C21.899 46.4394 23.1 46.4394 24.3244 46.4394C23.5089 48.0984 23.6515 49.3065 24.7333 50.1617C25.6586 50.893 26.9671 50.893 27.8877 50.1617C28.9672 49.3041 29.1098 48.1101 28.3013 46.4371H38.2202C38.6502 46.4371 39.0801 46.4371 39.5147 46.4371C38.6992 48.0961 38.8418 49.3041 39.9236 50.1593C40.8489 50.8907 42.1574 50.8907 43.0781 50.1593C44.1576 49.3018 44.3001 48.1078 43.4916 46.4348H44.4987C44.4987 46.4348 44.494 46.4231 44.4894 46.4161H48.0153V44.6963H37.4118V44.7244L37.4071 44.7314Z",
    fill: "#D0F19A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6304_50370"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.931641,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/Purchase.07bd96d852e4cd29cae32ac759c02481.svg";
export { ForwardRef as ReactComponent };